// extracted by mini-css-extract-plugin
module.exports = {"PitchingProfile":"_1BQNA1Vp","paragraph":"_1qP9FD7z","loadingBar":"_2PaEfxia"};